/**
 * DO NOT MODIFY THIS FILE!
 * It was created by the Reefer icons generator.
 * For updates, please re-run the generator.
 */

import type { SVGProps } from 'react';

import type { IconComponentProps } from '../../icon/icon.types';
import { Icon } from '../icon';

const Cbd = (props: SVGProps<SVGSVGElement>) => (
  <svg
    xmlns="http://www.w3.org/2000/svg"
    width="100%"
    height="100%"
    fill="none"
    className="Icon/CBD"
    viewBox="0 0 24 24"
    {...props}
  >
    <g className="Vector">
      <path
        fill="#0E0E0E"
        d="M18 20v2H6v-2zm2-2V6a2 2 0 0 0-2-2H6a2 2 0 0 0-2 2v12a2 2 0 0 0 2 2v2l-.206-.005a4 4 0 0 1-3.79-3.789L2 18V6a4 4 0 0 1 4-4h12a4 4 0 0 1 4 4v12a4 4 0 0 1-3.794 3.995L18 22v-2a2 2 0 0 0 2-2"
      />
      <path
        fill="#0E0E0E"
        d="M12.839 17.18q-1.23 0-2.235-.585t-1.605-1.71q-.585-1.14-.585-2.76 0-1.605.6-2.745.615-1.155 1.635-1.755 1.02-.615 2.25-.615.93 0 1.65.375t1.185.87l-.93 1.125q-.375-.39-.84-.615-.45-.24-1.02-.24-.795 0-1.425.435-.615.42-.975 1.215-.345.795-.345 1.905 0 1.68.735 2.64.735.945 1.965.945.66 0 1.17-.27.51-.285.93-.735l.93 1.095q-.6.69-1.38 1.065-.765.36-1.71.36"
      />
    </g>
  </svg>
);

export const CbdIcon = ({
  size = 'md',
  'data-testid': testId,
  ...props
}: IconComponentProps) => {
  return (
    <Icon
      data-testid={testId || 'cbd-icon'}
      icon={Cbd}
      {...props}
      size={size}
    />
  );
};
